/** Reads Django CSRF cookie for session-authenticated POST requests. */
const CSRF_COOKIE_NAME = 'csrftoken';

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const parts = `; ${document.cookie}`.split(`; ${name}=`);
  if (parts.length !== 2) return null;
  const raw = parts.pop()?.split(';').shift();
  return raw ? decodeURIComponent(raw) : null;
}

export function getCsrfToken(): string | null {
  return readCookie(CSRF_COOKIE_NAME);
}
